import { FC } from 'react'
import { Option, Select } from '@cargomart/ui'
import cn from 'classnames'
import { formattedOrderStatus } from 'modules/order/helpers'
import { TOption } from 'modules/order/pages/OrderList/types'
import { statusOptions } from 'modules/order/types'

import s from './OrderFilterSelect.module.less'

export interface OrderFilterStatusSelectProps {
  isLaptop: boolean
  onChange: (value: TOption[]) => void
  prefix: React.ReactNode
  status: TOption[] | null | undefined
}

export const OrderFilterStatusSelect: FC<OrderFilterStatusSelectProps> = ({ status, isLaptop, prefix, onChange }) => (
  <Select
    isMultiple
    className={cn(s.filterSelect, { [s.filterSelectActive]: status?.length })}
    fullscreenName="Статус"
    isFullscreen={isLaptop}
    maxOptionListWidth={290}
    onChange={onChange}
    prefix={prefix}
    value={status}
  >
    {statusOptions.map((option, index) => (
      <Option
        key={index}
        isCheckIcon
        className={cn(s.filterOption, s.filterStatusOption)}
        title={formattedOrderStatus(option.name)}
        value={option}
      />
    ))}
  </Select>
)
